module.exports = __webpack_public_path__ + "img/Brand.c45c0311.svg";